import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    button: {
        color: theme.palette.primary.main,
        background: '#FF66001A',
        padding: 16,
        borderRadius: 100,
        textAlign: 'center',
        cursor: 'pointer'
    }
}));

const Button = ({ text, onClick, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.button, className)} onClick={onClick}>
            {text}
        </div>
    );
};

Button.propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string
};

export default Button;
